import React, { forwardRef } from 'react';
import times from 'lodash/times';

import { cn } from '@lyearn/style';

import Box from '../../Box';
import Stack from '../../Stack';
import { LinearProgressProps } from '../types';
import { getLinearProgressSize } from '../utils';
import { setWidth } from './styles';
import { getLinearProgressSegmentClasses, getProgressBarStyles } from './utils';

const LinearProgress = forwardRef<HTMLDivElement, LinearProgressProps>((props, ref) => {
  const {
    className,
    color = 'primary',
    gap = 2,
    overrides,
    segments = 1,
    size = 'medium',
    value: valueProp,
    width,
  } = props;

  const value = valueProp ?? 0;
  const height = getLinearProgressSize(size);

  return (
    <Stack
      ref={ref}
      aria-valuenow={value}
      className={cn(className, height, width && setWidth(width))}
      gapX={gap}
      role="progressbar">
      {times(segments, (index) => {
        const classes = getLinearProgressSegmentClasses({ color, index, overrides, segments });
        const progressBar = getProgressBarStyles({ index, segments, value });

        return (
          <Box key={index} className={classes.root}>
            <Box className={classes.track} />
            {progressBar ? <Box className={cn(classes.progress, progressBar)} /> : null}
          </Box>
        );
      })}
    </Stack>
  );
});

export type { LinearProgressProps };
export default LinearProgress;
